import type { ShapeProps } from "./index";
import { generateRoundedPath } from "./utils";

export function Diamond({ width, height, ...svgAttributes }: ShapeProps) {
  return (
    <path
      d={generateRoundedPath(
        [
          [0, height / 2],
          [width / 2, 0],
          [width, height / 2],
          [width / 2, height],
        ],
        6,
      )}
      {...svgAttributes}
    />
  );
}
